$(function() {
    // Fancy box

    if ($('.fancybox').length > 0) {
        $('.fancybox').fancybox({
            openEffect: 'elastic',
            closeEffect: 'elastic',
            closeBtn: true
        });
    }

    if ($('.client-fancybox').length > 0) {
        $('.client-fancybox').fancybox({
            openEffect: 'elastic',
            closeEffect: 'elastic',
            closeBtn: true,
            maxWidth: 1200
        });
    }
});